module.exports = __webpack_public_path__ + "static/streetlevelMobile-073f582677722e5dc3a484ae94e0e4b1.jpg";